module.exports = __webpack_public_path__ + "img/IMG_9432_L_BlackMatted.4afd12e1.jpg";